export function Contacts() {
  return <>Contacts</>;
}
